module.exports = __webpack_public_path__ + "static/media/ico_simulation_nose_contour.3dae6209.png";